import { render, staticRenderFns } from "./ParamTipoRodado.vue?vue&type=template&id=62e12cc6"
import script from "./ParamTipoRodado.vue?vue&type=script&lang=js"
export * from "./ParamTipoRodado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports